import {
  IonList,
  IonItem,
  IonLabel,
  IonSkeletonText,
  IonText,
  IonThumbnail,
  IonRefresher,
  IonRefresherContent,
  useIonViewWillLeave,
  useIonViewDidEnter,
  IonListHeader
} from "@ionic/react";

import { RefresherEventDetail } from "@ionic/core";

import React from "react";

import { useHistory } from "react-router";
// import { useQuery } from "@apollo/react-hooks";
import moment from "moment";

import PageCmp from "../../components/Page/Page";
import NumberFormat from "../../components/NumberFormat";

import Status from "../../components/Passage/Status/status";
import PageError from "../Error";

import { BusStation } from "./BusStation";

import AvatarIcon from "../../assets/avatar.svg";

// import { Ticket } from "../../interfaces/ticket";

import { useTickets } from "../../hooks/useTickets";

import IonToolbar from "./IonToolbar";

const listLoading = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const Page: React.FC = () => {
  const { push } = useHistory();
  // const { loading }

  const { list, loading, error, listGroup, refetch } = useTickets();

  useIonViewDidEnter(() => {
    refetch();
  }, [loading])

  // const { loading, error, data, stopPolling, startPolling, refetch } = useQuery(
  //   GET_TICKETS,
  //   {
  //     fetchPolicy: "no-cache",
  //     pollInterval: 5000,
  //   }
  // );

  // useIonViewDidEnter(() => {
  //   // if (refetch && !loading && data !== undefined && state) refetch();
  //   if (startPolling) startPolling(5000);
  // }, [startPolling, refetch, loading]);

  // useIonViewWillLeave(() => {
  //   if (stopPolling) {
  //     stopPolling();
  //   }
  // }, [stopPolling]);

  const handleDetail = (id: number) => push(`/page/passage/${id}`);

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    refetch().then(() => {
      setTimeout(() => {
        event.detail.complete()
      }, 500);
    });
  };

  if (error) {
    return <PageError name="" error="network" />;
  }

  if (loading) {
    return (
      <PageCmp name="">
        <IonList>
          {listLoading.map((value) => (
            <IonItem key={value}>
              <IonSkeletonText
                animated
                style={{ width: "27px", height: "27px" }}
                slot="start"
              />
              <IonLabel>
                <h3>
                  <IonSkeletonText animated style={{ width: "50%" }} />
                </h3>
                <p>
                  <IonSkeletonText animated style={{ width: "80%" }} />
                </p>
                <p>
                  <IonSkeletonText animated style={{ width: "60%" }} />
                </p>
              </IonLabel>
            </IonItem>
          ))}
        </IonList>
      </PageCmp>
    );
  }

  return (
    <PageCmp name="" ionToolBar={<IonToolbar />}>
      {/* <BusStation show={getTickets.length === 0} /> */}
      {/* <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
        <IonRefresherContent />
      </IonRefresher> */}
      <div style={{overflowY: "scroll"}}>
        {listGroup.map((item, index) => (
          <IonList key={`${index}-${item.datetime.format("DD-MM-YYYY")}`}>
            <IonItem button lines="none">
              <IonListHeader style={{paddingLeft: "0px"}}>
                <h5 style={{fontSize: 16, marginTop: 10}}>{item.arrivalLocation.name} X {item.departureLocation.name}{" - "}{item.datetime.format("DD/MM")} às {item.datetime.format("HH")}:{item.datetime.format("mm")} ({item.items.length})</h5>
              </IonListHeader>
            </IonItem>
            {item.items.map(({ id, date, hour, minutes, price, status, car, client }, index) => (
              <IonItem button key={id} onClick={() => handleDetail(id)}>
                <IonThumbnail slot="start">
                  <img
                    style={{ borderRadius: "50%" }}
                    src={client?.photo || AvatarIcon}
                    alt={client?.name}
                  />
                </IonThumbnail>
                <IonLabel className="ion-text-wrap">
                  <IonText>
                    <h3>
                      {client?.name}
                    </h3>
                  </IonText>
                  <p>
                    <NumberFormat value={price} />
                  </p>
                  <p>
                    {/* <IonSkeletonText animated style={{ width: "60%" }} /> */}
                  </p>
                </IonLabel>
                <Status type={status} />
              </IonItem>
            ))}
          </IonList>
        ))}
      </div>
    </PageCmp>
  );
};

export default Page;
